import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom'
import { changeSessionData } from '../../store/reducers/sessionSlice';
import './NavBar.css';
import { getPermissions } from '../../utils/various';

const NavBar = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { sessionData } = useSelector(state => state.session);
    const permissions = getPermissions(sessionData?.role);

    const handleNavigate = (path) => {
        navigate('/' + path);
    }

    const handleLogout = () => {
        dispatch(changeSessionData(null));
    }

    //generate navbar component
    return (
        sessionData &&
        <div className="flex sticky top-0 items-center justify-between w-full h-[50px] min-h-[50px] navbar z-50">
            <ul onClick={handleLogout} className="flex flex-row items-center gap-2 mx-10 text-white duration-500 hover:text-slate-500">
                <li className="text-white duration-500 cursor-pointer hover:text-slate-500">Cerrar sesión</li>
                <li className="text-white duration-500">({sessionData.username})</li>
            </ul>
            <ul className="flex flex-row items-center gap-10 mx-10 text-white">
                <li className="duration-500 cursor-pointer hover:text-slate-500" onClick={() => handleNavigate('')} >Inicio</li>
                <li className="duration-500 cursor-pointer hover:text-slate-500" onClick={() => handleNavigate('contracts')}>Contratos</li>
                <li className="duration-500 cursor-pointer hover:text-slate-500" onClick={() => handleNavigate('requests')}>Solicitudes</li>
                {permissions.admin && <li className="duration-500 cursor-pointer hover:text-slate-500" onClick={() => handleNavigate('report')}>Reporte</li>}
                {permissions.admin && <li className="duration-500 cursor-pointer hover:text-slate-500" onClick={() => handleNavigate('users')}>Usuarios</li>}
            </ul>
        </div>
    )
}

export default NavBar